import { useTranslation } from 'react-i18next';
import { TextV2, SwitchV2 } from '@insights-ltd/design-library/components';
import { Box, Divider } from '@mui/material';
import { getTheme } from '@insights-ltd/design-library/themes';
import { SaveState } from './types';

const localTheme = getTheme();

type AiFeatureSectionProps = {
  isEnabled: boolean;
  saveState: SaveState;
  onToggle: (enabled: boolean) => void;
};

export function AiFeatureSection({
  isEnabled,
  saveState,
  onToggle,
}: AiFeatureSectionProps) {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr auto',
          gridTemplateRows: 'auto auto',
          columnGap: 4,
          rowGap: 0.5,
          py: 4,
        }}
      >
        <TextV2 variant="bodyBold" sx={{ gridColumn: '1', gridRow: '1' }}>
          {t(
            'ui.event-management.organisations.feature-access.ai-feature.title',
          )}
        </TextV2>

        <TextV2 color="textSecondary" sx={{ gridColumn: '1', gridRow: '2' }}>
          {t(
            'ui.event-management.organisations.feature-access.ai-feature.description',
          )}
        </TextV2>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            gridColumn: '2',
            gridRow: '2',
          }}
        >
          <SwitchV2
            id="ai-feature-switch"
            checked={isEnabled}
            onChange={onToggle}
            value={isEnabled}
            labelLeft={t(
              'ui.event-management.organisations.feature-access.switch.off',
            )}
            labelRight={t(
              'ui.event-management.organisations.feature-access.switch.on',
            )}
          />

          {saveState === 'saved' && (
            <Box
              sx={{
                backgroundColor: localTheme.validationColours.lightValid,
                borderRadius: '4px',
                px: 1,
                py: 0,
              }}
            >
              <TextV2 variant="bodySmall" sx={{ color: '#0D6C51' }}>
                {t('ui.event-management.organisations.feature-access.saved')}
              </TextV2>
            </Box>
          )}

          {saveState === 'error' && (
            <Box
              sx={{
                backgroundColor: localTheme.validationColours.lightError,
                borderRadius: '4px',
                px: 1,
                py: 0,
              }}
            >
              <TextV2
                variant="bodySmall"
                sx={{ color: localTheme.validationColours.error }}
              >
                {t('ui.event-management.organisations.feature-access.error')}
              </TextV2>
            </Box>
          )}
        </Box>
      </Box>
      <Divider />
    </>
  );
}
